import { __awaiter, __generator } from "tslib";
import axiosInstance from "../axiosInstance";
import endpoints from "../endpoints";
export var getTrips = function () { return __awaiter(void 0, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axiosInstance.post("".concat(endpoints.api.getFilteredTrips), {})];
            case 1:
                res = _a.sent();
                return [2 /*return*/, res.data.result];
        }
    });
}); };
export var getTripDetails = function (tripId) { return __awaiter(void 0, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axiosInstance.get("".concat(endpoints.api.getTripDetails, "/").concat(tripId))];
            case 1:
                res = _a.sent();
                return [2 /*return*/, res.data.result];
        }
    });
}); };
export var tripMembershipAction = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axiosInstance.post("".concat(endpoints.api.tripMembershipAction), payload)];
            case 1:
                res = _a.sent();
                return [2 /*return*/, res.data];
        }
    });
}); };
